import * as React from "react";
import { Switch, SwitchProps } from "antd";
import { formSet, formSetValue, useCpFormValue } from "./utils";
import { store } from "../../../store";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props extends Omit<SwitchProps, "id" | "name" | "value" | "status"> {
  name: string;
}
export const CpSwitch = (props: Props): React.ReactElement => {
  const { id } = useCpFormContext();

  const { name, onChange, size: _size, ...switchProps } = props;

  const value = useCpFormValue(name);

  const fieldStatePath = React.useMemo(() => `fieldStates.${name}`, [name]);

  React.useEffect(() => {
    formSet(id, `fieldStates.${name}.visited`, true);
    formSet(id, `fieldStates.${name}.touched`, true);
  }, []);

  const size = _size || "small";

  return (
    <Switch
      {...switchProps}
      id={name}
      value={value}
      size={size}
      onChange={(checked, e) => {
        onChange?.(checked, e);
        formSetValue(id, name, checked);

        formSet(id, `${fieldStatePath}.modified`, true);

        const form = store.getState().form.instances[id];

        const onChangeCounter = form.meta.onChangeCounter;
        formSet(id, `meta.onChangeCounter`, onChangeCounter + 1);

        const onBlurCounter = form.meta.onBlurCounter;
        formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
      }}
    />
  );
};
